export default __webpack_public_path__ + "static/trust-ec3a84a5f98e78ca8792f9e6905db60f.jpg";